import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import Typography from '@material-ui/core/Typography';

function PrivacyLink({ privacyUrl, privacyText }) {
    return (
        <a css={linkStyle} href={privacyUrl} target="_blank" rel="noopener noreferrer">
            <Typography variant="caption">{privacyText || i18n.t('label.privacy_rule')}</Typography>
        </a>
    );
}

PrivacyLink.propTypes = {
    privacyUrl: PropTypes.string,
    privacyText: PropTypes.string
};

export default PrivacyLink;

const linkStyle = css`
    text-decoration: none;
`;
